/**
 * The origin this storefront is actually served from — the single source of
 * truth for canonical, og:url, og:image, sitemap and robots.txt URLs.
 *
 * This lives in a `.cjs` so the build-time config files (gatsby-config.js,
 * gatsby-node.js) and the browser bundle can all share one definition.
 * Repeating the fallback in each of them is exactly how they drift apart.
 *
 * It is deliberately NOT GATSBY_TTF_SITE_URL: that value is sent to the API as
 * the `Origin` header and is registered backend-side, so it is not free to
 * follow wherever the public site is hosted.
 *
 * For ClickPass the two genuinely differ, which is why GATSBY_TTF_SITE_URL is
 * absent from the chain below rather than sitting in it as a fallback: it is
 * clickpass.mx, a separate marketing site that 404s on /events/. Falling
 * through to it would quietly point every canonical at another domain.
 *
 * There is no trailing slash; callers append a path that starts with one.
 */
const CANONICAL_ORIGIN = (
  process.env.GATSBY_TTF_CANONICAL_ORIGIN || "https://tickets.clickpass.mx"
).replace(/\/+$/, "")

module.exports = { CANONICAL_ORIGIN }
